import IconDownload from "../../../public/image/svg/download.svg";
import styles from "../C37.5_EventDetail.module.scss";

const AttachmentsSection = (props: { attachments: any[] }) => {
  const { attachments } = props;

  return (
    <ul className={styles["download-list"]}>
      {attachments &&
        attachments.length > 0 &&
        attachments.map((attachment, index) => (
          <li key={`attachment-${index}`}>
            <IconDownload aria-hidden />
            {/* TODO: Update link to download media */}
            <a href={attachment?.url}>{attachment?.title}</a>
          </li>
        ))}
    </ul>
  );
};

export default AttachmentsSection;
